<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar color="error" height="60" dark class="elevation-0">
        <v-toolbar-title>{{ tempEvent.typeName }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="tempEvent.status > 4 && type == 'edit'" icon small @click.prevent="onRemoveDialog(tempEvent)" class="ma-0"><v-icon class="white--text">delete</v-icon></v-btn>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card flat tile>
        <v-card-text class="py-0 px-2">
          <v-row class="ma-0">
            <template v-if="tempEvent.status == '1'">
              <v-col cols="6" class="pa-0">
                <template-date-picker
                  :id="0"
                  :icon="'event'"
                  :date="inquiry"
                  :label="'問合せ日'"
                  :title="false"
                  @updated="onUpdated"
                  hide-details
                  :disabled="type == 'view'"
                ></template-date-picker>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-select
                  prepend-icon="mdi-earth"
                  :items="$MEDIAS"
                  label="媒体"
                  v-model="tempEvent.media"
                  hide-details
                  item-text="name"
                  item-value="key"
                  @change="isModified = true"
                  :disabled="type == 'view'"
                ></v-select>
              </v-col>
            </template>
            <template v-if="tempEvent.status == '2' || tempEvent.status == '3' || tempEvent.status == '5' ||
              (tempEvent.status == 6 && (tempEvent.type == 1 || tempEvent.type == 2 || tempEvent.type == 3 || tempEvent.type === 5 || tempEvent.type == 6))">
              <v-col cols="6" class="pa-0">
                <template-date-picker
                  :id="3"
                  :icon="'event'"
                  :date="tempEvent.date1"
                  :label="tempEvent.status == '5' ? (extension == 1 ? '入会日' : '入塾日') : '実施日'"
                  :title="false"
                  @updated="onUpdated"
                  :validate="validate"
                  :clearable="tempEvent.status == '5' ? false : true"
                  :disabled="type == 'view'"
                ></template-date-picker>
              </v-col>
              <v-col v-if="tempEvent.status == '2' || tempEvent.status == '3'" cols="4" class="pa-0">
                <template-time-picker
                  :id="1"
                  :icon="'access_time'"
                  :time="tempEvent.time1"
                  :label="'時刻'"
                  @updated="onUpdated"
                  :clearable="true"
                  :disabled="type == 'view'"
                ></template-time-picker>
              </v-col>
            </template>
            <template v-if="tempEvent.status == '1'">
              <v-col cols="12" class="px-0">
                <v-select
                  ref="room"
                  prepend-icon="location_city"
                  :items="tempGroups"
                  label="教室"
                  v-model="group"
                  class="mr-1"
                  hide-details
                  item-text="name"
                  item-value="key"
                  :rules="[rules.required]"
                  disabled
                  @change="isModified = true"
                ></v-select>
              </v-col>
              <v-col cols="8" class="pa-0">
                <template-date-picker
                  :id="3"
                  :icon="'event'"
                  :date="tempEvent.date1"
                  :label="'保護者面談日（予約）'"
                  :title="false"
                  @updated="onUpdated"
                  :disabled="type == 'view'"
                ></template-date-picker>
              </v-col>
              <v-col cols="4" class="pa-0">
                <template-time-picker
                  :id="1"
                  :icon="'access_time'"
                  :time="tempEvent.time1"
                  :label="'時刻'"
                  @updated="onUpdated"
                  :disabled="type == 'view'"
                ></template-time-picker>
              </v-col>
              <v-col cols="8" class="pa-0">
                <template-date-picker
                  :id="4"
                  :icon="'event'"
                  :date="tempEvent.date2"
                  :label="'体験授業日（予約）'"
                  :title="false"
                  @updated="onUpdated"
                  :disabled="type == 'view'"
                ></template-date-picker>
              </v-col>
              <v-col cols="4" class="pa-0">
                <template-time-picker
                  :id="2"
                  :icon="'access_time'"
                  :time="tempEvent.time2"
                  :label="'時刻'"
                  @updated="onUpdated"
                  :disabled="type == 'view'"
                ></template-time-picker>
              </v-col>
            </template>
            <template v-if="tempEvent.status == 6 && tempEvent.type == 4">
              <v-col cols="2" class="pb-0 px-0">
                <v-select
                  ref="tygs"
                  :items="$YCSS"
                  label="YCS"
                  v-model="tempEvent.tyg"
                  class="mx-1"
                  dense
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="key"
                  hide-details
                  @change="isModified = true"
                  :disabled="type == 'view'"
                ></v-select>
              </v-col>
            </template>
            <v-col cols="12" class="pb-0 px-0">
              <template-memo
                :label="'メモ'"
                :event="tempEvent"
                :rules="[]"
                :attach="true"
                :files="files"
                :type="type"
                @update="onUpdateMemo"
              >
              </template-memo>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded depressed @click.native="onClose()">取消</v-btn>
          <v-btn  v-if="type == 'edit'" :disabled="!isModified" rounded depressed color="error" @click="onChangeDialog(tempEvent)">更新</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='削除'
        :message="getTypeName() +  ' を削除します。よろしいですか?'"
        :dialog='removeDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='変更'
        :message="getTypeName() +  ' を変更します。よろしいですか?'"
        :dialog='changeDialog'
        color="error"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='日付'
        :message="extension == 1 ? '入会日（退会日）は退会日（入会日）の前（後）に指定できません' : '入塾日（退塾日）は退塾日（入塾日）の前（後）に指定できません'"
        :dialog='dateErrorDialog'
        color="error"
        :cancel='false'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as async from 'async'
import moment from 'moment-timezone'

import DatePicker from '../common/TemplateDate.vue'
Vue.component('template-date-picker', DatePicker)
export default {
  computed: {
    ...mapGetters({
      data: 'auth/data',
      groups: 'groups/groups',
      extension: 'shared/extension'
    })
  },
  props: [ 'item', 'event', 'type' ],
  data () {
    return {
      tempItem: null,
      tempEvent: null,
      removeEvent: null,
      removeDialog: false,
      changeDialog: false,
      dateErrorDialog: false,
      loading: false,
      validate: false,
      isModified: false,
      tempGroups: [],
      inquiry: null,
      files: [],
      rules: {
        required: value => !!value || '必須'
      },
      group: null
    }
  },
  created () {
    this.tempEvent = JSON.parse(JSON.stringify(this.event))
    this.tempItem = JSON.parse(JSON.stringify(this.item))
    this.inquiry = moment.unix((this.event.updatedAt / 1000)).format('YYYY-MM-DD')
    this.isModified = false
    this.createGroups()
  },
  methods: {
    createGroups () {
      this.tempGroups = []
      if (typeof this.data.groups === 'undefined') {
        return
      }
      if (this.checkPrimary()) {
        var sKeys = Object.keys(this.data.schools)
        for (var index in this.groups) {
          for (var x in sKeys) {
            if (this.data.schools[sKeys[x]]) {
              if (this.groups[index].classroom) {
                if (this.groups[index].schools[sKeys[x]]) {
                  this.tempGroups.push(this.groups[index])
                }
              }
            }
          }
        }
      } else {
        var school = this.getPrimary()
        if (school !== null) {
          var keys = Object.keys(school.groups)
          for (var i in keys) {
            if (school.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
      }
      keys = Object.keys(this.item.groups)
      for (i in keys) {
        if (this.item.groups[keys[i]]) {
          this.group = keys[i]
        }
      }
    },
    getTypeName () {
      if (this.tempEvent.status === 6) {
        var index = this.$ACTIONS.findIndex(a => a.key === this.tempEvent.type)
        if (index !== -1) {
          return this.$ACTIONS[index].name
        }
      } else if (this.tempEvent.status === 5) {
        return this.extension === 1 ? '入会以降のステータスを全て' : '入塾以降のステータスを全て'
      } else {
        index = this.$STATUS.findIndex(a => a.key === this.tempEvent.status)
        if (index !== -1) {
          return this.$STATUS[index].name
        }
      }
      return ''
    },
    onClose () {
      this.$emit('dismissed')
    },
    onDismissed: function (value) {
      if (this.dateErrorDialog) {
        this.dateErrorDialog = false
        return
      }
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          this.onRemoveEvent()
        }
        return
      }
      if (this.changeDialog) {
        this.changeDialog = false
        if (value) {
          this.onChangeEvent()
        }
      }
    },
    onUpdated: function (value) {
      switch (value.id) {
        case 0:
          this.inquiry = value.date
          break
        case 1:
          this.tempEvent.time1 = value.time
          break
        case 2:
          this.tempEvent.time2 = value.time
          break
        case 3:
          this.tempEvent.date1 = value.date
          break
        case 4:
          this.tempEvent.date2 = value.date
          break
      }
      this.isModified = true
    },
    onUpdateMemo: function (value) {
      this.tempEvent = value.item
      this.isModified = true
    },
    onChangeDialog (item) {
      this.changeEvent = item
      if (item.status === 5 && this.item.graduation) {
        moment.tz.setDefault('Asia/Tokyo')
        var from = moment(this.tempEvent.date1)
        var to = moment(this.item.graduation)
        if (from.diff(to) > 0) {
          this.dateErrorDialog = true
          return
        }
      }
      this.changeDialog = true
    },
    fwrite (file) {
      var vm = this
      return new Promise((resolve) => {
        vm.$store.dispatch('storage/write', { blob: file.blob, child: 'students', id: vm.tempItem.key, uuid: vm.genUUIDv4() }).then(function (resp) {
          resolve(resp)
        })
      })
    },
    storeFiles () {
      var vm = this
      this.loading = true
      return new Promise((resolve) => {
        async.eachSeries(this.files, function (file, cb) {
          vm.fwrite(file).then(function (resp) {
            if (resp) {
              var payload = vm.changeEvent.attaches ? JSON.parse(JSON.stringify(vm.changeEvent.attaches)) : []
              payload.push({
                name: file.name,
                mime: file.mime,
                size: file.size,
                path: resp.path,
                thumbnail: resp.thumbnail
              })
              vm.changeEvent.attaches = payload
            }
            cb()
          })
        }, function (error) {
          if (error) {
          }
          vm.loading = false
          resolve()
        })
      })
    },
    onChangeEvent () {
      var vm = this
      this.changeDialog = false
      this.changeEvent.counter += 1
      if (this.changeEvent.status === 1) {
        this.changeEvent.updatedAt = parseInt(new Date(this.inquiry).getTime())
      }
      this.storeFiles().then(function () {
        var payload = JSON.parse(JSON.stringify(vm.$store.getters['students/event']))
        var keys = Object.keys(payload)
        for (var i in keys) {
          payload[keys[i]] = vm.changeEvent[keys[i]]
        }
        vm.$emit('dismissed', { action: 'change', event: payload })
      })
    },
    onRemoveDialog (item) {
      this.removeEvent = item
      this.removeDialog = true
    },
    onRemoveEvent () {
      this.removeDialog = false
      this.$emit('dismissed', { action: 'remove', event: this.removeEvent })
    }
  }
}
</script>
